import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleHero from "./components/ArticleHero";
import ArticleContent from "./components/ArticleContent";
import RelatedArticles from "./components/RelatedArticles";
import ArticleCTA from "./components/ArticleCTA";
import FAQSection from "./components/FAQSection";
import { articles } from "@/mocks/article";
import { useParams, Link } from "react-router-dom";

export default function Article() {
  const { id } = useParams<{ id: string }>();
  const article = articles.find((a) => a.id === id);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-20 flex items-center justify-center bg-background-100">
          <div className="text-center px-4">
            <p className="text-foreground-500 text-lg mb-4">
              文章不存在或已被删除
            </p>
            <Link
              to="/"
              className="whitespace-nowrap inline-block px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-foreground-50 font-medium rounded-full transition-all duration-200"
            >
              返回首页继续吃瓜
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const breadcrumbJsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "首页",
        item: "https://zaixianchigua.com",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: article.category,
        item: `https://zaixianchigua.com/category/${article.categorySlug}`,
      },
      {
        "@type": "ListItem",
        position: 3,
        name: article.title,
        item: `https://zaixianchigua.com/article/${article.id}`,
      },
    ],
  };

  const articleJsonLd = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.title,
    description: article.summary,
    datePublished: article.date,
    author: {
      "@type": "Organization",
      name: "在线吃瓜官网",
    },
    publisher: {
      "@type": "Organization",
      name: "在线吃瓜官网",
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `https://zaixianchigua.com/article/${article.id}`,
    },
  };

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "你们的信息来源可靠吗？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "我们所有爆料内容均来自公开信息和多方交叉验证。每篇报道都会标注信息来源，确保内容真实可信。对于无法核实的信息，我们会明确标注\"未经证实\"。",
        },
      },
      {
        "@type": "Question",
        name: "爆料人的隐私如何保护？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "我们严格保护所有爆料人的个人信息，所有投稿均采用匿名处理。我们永远不会在未经爆料人同意的情况下公开任何可以识别其身份的信息。",
        },
      },
      {
        "@type": "Question",
        name: "可以投稿爆料吗？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "当然可以！我们欢迎所有真实、有据可查的爆料。请通过我们的官方邮箱或社交媒体私信提交，我们的编辑团队会在24小时内审核并回复。",
        },
      },
      {
        "@type": "Question",
        name: "被爆料方要求删除内容怎么办？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "我们始终坚持新闻真实性原则。如果被爆料方能够提供确凿证据证明我们的报道存在失实，我们会立即更正。但如果报道内容属实，我们不会因为外部压力而撤稿。",
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(breadcrumbJsonLd),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <Navbar />
      <main>
        <ArticleHero
          title={article.title}
          category={article.category}
          categorySlug={article.categorySlug}
          date={article.date}
          views={article.views}
          comments={article.comments}
          shares={article.shares}
          heroImageUrl={article.heroImageUrl}
        />
        <ArticleContent
          content={article.content}
          tags={article.tags}
          shares={article.shares}
          comments={article.comments}
        />
        <RelatedArticles relatedIds={article.relatedArticles} />
        <ArticleCTA ctaImageUrl={article.ctaImageUrl} />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}